export type QualificationQuestion = {
  key: "source" | "industry" | "position" | "company" | "phone" | "country" | "qty_of_senders" | "job_type" | "linkedin_url"
  question_text: string
  options: string[]
  other_option: boolean
}

export const gsQualificationQuestion: QualificationQuestion[] = [
  // {
  //   key: "linkedin_url",
  //   question_text: "Your personal LinkedIn profile URL",
  //   options: [],
  //   other_option: true,
  // },
  {
    key: "qty_of_senders",
    question_text: "How many LinkedIn accounts does your team use for outreach?",
    options: [
      "50+ accounts",
      "20+ accounts",
      "10+ accounts",
      "1-10 accounts",
    ],
    other_option: false,
  },
  {
    key: "job_type",
    question_text: "What do you want to use GetSales for?",
    options: [
      "Generate qualified leads and find new clients",
      "Source and engage candidates",
      "Find investors or partners",
      "Support email & inbound with LinkedIn outreach",
    ],
    other_option: true,
  },
  {
    key: "industry",
    question_text: "Which industry describes your business best?",
    options: [
      "Agency booking sales appointments",
      "GTM expert / leadgen integrator",
      "IT services / IT staffing",
      "Recruitment agency",
      "Individual / Solopreneur / Entrepreneur",
      "SaaS product",
      "Marketing agency",
    ],
    other_option: true,
  },
  {
    key: "source",
    question_text: "How did you hear about us?",
    options: [
      "Friend recommended",
      "Hooked by GetSales outreach",
      "MirrorProfiles",
      "LinkedIn posts / Influencer",
      "Teammate invited me",
      "Agency/integrator signed me up",
      "Slack / Discord / Telegram / Facebook groups",
      "Used GetSales before",
      "Google / ChatGPT search",
      "Leadgen course / training",
      "Paid ad",
      "Review platforms (G2 / Trustpilot / Capterra)",
    ],
    other_option: true,
  },
];
